var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPinTickFill = function SvgPinTickFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#171717",
    d: "m11.15 13.14 4.764-4.77-1.2-1.195-3.564 3.564-1.625-1.625-1.2 1.2zm.85 9.132q-4.124-3.5-6.164-6.508T3.796 10.2q0-3.855 2.472-6.14Q8.74 1.77 11.994 1.77q3.252 0 5.744 2.288 2.49 2.287 2.491 6.142 0 2.556-2.052 5.564-2.054 3.008-6.177 6.507"
  })));
};
export default SvgPinTickFill;